 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_FRONTCOVER from '@/components/00_frontcover'
 import A1_TITLE from '@/components/01_title'
 import A1A_DEDICATION from '@/components/01A_dedication'
 import A1B_COPYRIGHTPAGE from '@/components/01B_copyrightPage'
 import A2_CONTENTS from '@/components/02_contents'
 import A3_ILLUSTRATIONS from '@/components/03_illustrations'
 import A4_PLATES from '@/components/04_plates'
 import A5_INTRODUCTION from '@/components/05_introduction'
 import A6_INTRODUCTION1 from '@/components/06_introduction1'
 import A7_CHAPTER01 from '@/components/07_chapter01'
 import A8_CHAPTER02 from '@/components/08_chapter02'
 import A9_CHAPTER03 from '@/components/09_chapter03'
 import A0_CHAPTER031 from '@/components/10_chapter031'
 import A1_CHAPTER032 from '@/components/11_chapter032'
 import A2_CHAPTER033 from '@/components/12_chapter033'
 import A3_CHAPTER034 from '@/components/13_chapter034'
 import A4_CHAPTER04 from '@/components/14_chapter04'
 import A5_CHAPTER041 from '@/components/15_chapter041'
 import A6_CHAPTER042 from '@/components/16_chapter042'
 import A7_CHAPTER043 from '@/components/17_chapter043'
 import A8_CHAPTER044 from '@/components/18_chapter044'
 import A9_CHAPTER045 from '@/components/19_chapter045'
 import A0_CHAPTER046 from '@/components/20_chapter046'
 import A1_CHAPTER047 from '@/components/21_chapter047'
 import A2_CHAPTER048 from '@/components/22_chapter048'
 import A3_CHAPTER05 from '@/components/23_chapter05'
 import A4_CHAPTER051 from '@/components/24_chapter051'
 import A5_CHAPTER052 from '@/components/25_chapter052'
 import A6_CHAPTER06 from '@/components/26_chapter06'
 import A7_CHAPTER061 from '@/components/27_chapter061'
 import A8_CHAPTER062 from '@/components/28_chapter062'
 import A9_CHAPTER07 from '@/components/29_chapter07'
 import A0_CHAPTER071 from '@/components/30_chapter071'
 import A1_CHAPTER072 from '@/components/31_chapter072'
 import A2_CHAPTER073 from '@/components/32_chapter073'
 import A3_CHAPTER074 from '@/components/33_chapter074'
 import A4_CHAPTER08 from '@/components/34_chapter08'
 import A5_CHAPTER09 from '@/components/35_chapter09'
 import A6_CHAPTER10 from '@/components/36_chapter10'
 import A7_CHAPTER11 from '@/components/37_chapter11'
 import A8_CHAPTER111 from '@/components/38_chapter111'
 import A9_CHAPTER112 from '@/components/39_chapter112'
 import A0_CHAPTER113 from '@/components/40_chapter113'
 import A1_CHAPTER114 from '@/components/41_chapter114'
 import A2_CHAPTER115 from '@/components/42_chapter115'
 import A3_CHAPTER116 from '@/components/43_chapter116'
 import A4_CHAPTER117 from '@/components/44_chapter117'
 import A5_CHAPTER118 from '@/components/45_chapter118'
 import A6_CHAPTER119 from '@/components/46_chapter119'
 import A7_CHAPTER1110 from '@/components/47_chapter1110'
 import A8_CHAPTER1111 from '@/components/48_chapter1111'
 import A9_CHAPTER1112 from '@/components/49_chapter1112'
 import A0_CHAPTER1113 from '@/components/50_chapter1113'
 import A1_CHAPTER1114 from '@/components/51_chapter1114'
 import A2_CHAPTER1115 from '@/components/52_chapter1115'
 import A3_CHAPTER1116 from '@/components/53_chapter1116'
 import A4_CHAPTER1117 from '@/components/54_chapter1117'
 import A5_CHAPTER1118 from '@/components/55_chapter1118'
 import A6_CHAPTER12 from '@/components/56_chapter12'
 import A7_CHAPTER13 from '@/components/57_chapter13'
 import A8_CHAPTER14 from '@/components/58_chapter14'
 import A9_CHAPTER15 from '@/components/59_chapter15'
 import A0_CHAPTER16 from '@/components/60_chapter16'
 import A1_CHAPTER161 from '@/components/61_chapter161'
 import A2_CHAPTER162 from '@/components/62_chapter162'
 import A3_CHAPTER17 from '@/components/63_chapter17'
 import A4_CHAPTER18 from '@/components/64_chapter18'
 import A5_APPENDIX01 from '@/components/65_appendix01'
 import A6_APPENDIX02 from '@/components/66_appendix02'
 import A7_NOTES from '@/components/67_notes'
 import A8_BIBLIOGRAPHY from '@/components/68_bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/02_contents",
 			"name" : "02_contents",
 			"component" : A2_CONTENTS
 		},
 		{
 			"path" : "/03_illustrations",
 			"name" : "03_illustrations",
 			"component" : A3_ILLUSTRATIONS
 		},
 		{
 			"path" : "/04_plates",
 			"name" : "04_plates",
 			"component" : A4_PLATES
 		},
 		{
 			"path" : "/05_introduction",
 			"name" : "05_introduction",
 			"component" : A5_INTRODUCTION
 		},
 		{
 			"path" : "/06_introduction1",
 			"name" : "06_introduction1",
 			"component" : A6_INTRODUCTION1
 		},
 		{
 			"path" : "/07_chapter01",
 			"name" : "07_chapter01",
 			"component" : A7_CHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js